const asistantServiceOptions = [
  { value: 1, option: 'Salón de Clase' },
  { value: 2, option: 'Transportación' },
  { value: 3, option: 'Ambos' },
];

export default asistantServiceOptions;
